(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('category-carousel')) {
    class CategoryCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.frame = 0;
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };

        this.track.addEventListener('scroll', this.schedule, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.schedule);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      // Sets the physical left/right fade widths from the scroll position.
      // Works in LTR and RTL: in RTL, scrollLeft runs from 0 (start) to -max.
      update() {
        const track = this.track;
        const styles = getComputedStyle(track);
        const fade = parseFloat(styles.getPropertyValue('--cc-fade')) || 0;
        const max = track.scrollWidth - track.clientWidth;
        let left = 0;
        let right = 0;

        if (max > 1 && fade > 0) {
          const offset = styles.direction === 'rtl' ? max + track.scrollLeft : track.scrollLeft;
          const fromLeft = Math.min(Math.max(offset, 0), max);
          left = Math.min(fromLeft, fade);
          right = Math.min(max - fromLeft, fade);
        }

        track.style.setProperty('--cc-fade-left', left + 'px');
        track.style.setProperty('--cc-fade-right', right + 'px');
        track.toggleAttribute('data-fade', left > 0.5 || right > 0.5);
      }
    }

    customElements.define('category-carousel', CategoryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-showcase')) {
    class FeaturedShowcase extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.nav = this.querySelector('[data-nav]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.frame = 0;
        this.lastEdge = null;

        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };
        this.goPrev = () => this.page(-1);
        this.goNext = () => this.page(1);

        // Image dots: scroll this card's gallery to the chosen image.
        this.onDotClick = (event) => {
          const dot = event.target instanceof Element ? event.target.closest('[data-dot]') : null;
          if (!dot) return;

          const card = dot.closest('.fps-card');
          const slides = card ? card.querySelector('[data-slides]') : null;
          if (!slides) return;

          const index = Number(dot.dataset.dot) || 0;
          const rtl = getComputedStyle(slides).direction === 'rtl';
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          slides.scrollTo({
            left: (rtl ? -1 : 1) * index * slides.clientWidth,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        };

        // Keeps the dots in sync while the gallery is swiped (scroll does not bubble, so capture it).
        this.onSlidesScroll = (event) => {
          const slides = event.target;
          if (!(slides instanceof Element) || !slides.hasAttribute('data-slides')) return;

          const width = slides.clientWidth;
          if (!width) return;

          const index = Math.round(Math.abs(slides.scrollLeft) / width);
          const card = slides.closest('.fps-card');
          if (!card) return;

          card.querySelectorAll('[data-dot]').forEach((item, i) => {
            item.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        };

        this.track.addEventListener('scroll', this.schedule, { passive: true });
        this.addEventListener('click', this.onDotClick);
        this.addEventListener('scroll', this.onSlidesScroll, { capture: true, passive: true });
        if (this.prevButton) this.prevButton.addEventListener('click', this.goPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.goNext);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.schedule);
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.schedule);
        }

        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.schedule);
        this.removeEventListener('click', this.onDotClick);
        this.removeEventListener('scroll', this.onSlidesScroll, { capture: true });
        window.removeEventListener('resize', this.schedule);
        if (this.prevButton) this.prevButton.removeEventListener('click', this.goPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.goNext);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      // Scrolls one "page" of cards. direction: 1 = forward in reading order, -1 = back.
      // Works in LTR and RTL (in RTL, forward means scrolling towards the left).
      page(direction) {
        const track = this.track;
        const styles = getComputedStyle(track);
        const rtl = styles.direction === 'rtl';
        const gap = parseFloat(styles.columnGap) || 0;
        const first = track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
        const visible = Math.max(1, Math.round(track.clientWidth / step));
        const sign = direction * (rtl ? -1 : 1);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        track.scrollBy({ left: sign * step * visible, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        const track = this.track;
        const rtl = getComputedStyle(track).direction === 'rtl';
        this.dataset.dir = rtl ? 'rtl' : 'ltr';

        // Measure the page margin so the scroller's edge padding (and scroll-snap padding)
        // line the first card up with the heading exactly.
        const wrapper = this.closest('.featured-showcase');
        if (wrapper && this.clientWidth > 0) {
          const edge = Math.max(0, Math.round(((wrapper.clientWidth - this.clientWidth) / 2) * 100) / 100);
          if (edge !== this.lastEdge) {
            this.lastEdge = edge;
            track.style.setProperty('--fps-edge', edge + 'px');
          }
        }

        // scrollLeft is 0 at the start edge and runs negative in RTL, so use its absolute value.
        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);

        if (this.nav) this.nav.hidden = max <= 2;
        if (this.prevButton) this.prevButton.disabled = position <= 2;
        if (this.nextButton) this.nextButton.disabled = position >= max - 2;
      }
    }

    customElements.define('featured-showcase', FeaturedShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
